import { useAssetListFilter, useSetAssetListFilter } from '@gripp/shared-logic';
import { useTranslation } from 'react-i18next';
import { SearchWrapper } from './searchWrapper';

export type AssetSearchProps = {
  mode: 'page' | 'modal';
  onBack?: () => void;
  onDismiss?: () => void;
  isVisible?: boolean;
};

export function AssetSearch({ mode, onBack, onDismiss, isVisible }: AssetSearchProps) {
  const { t } = useTranslation();
  const { data: assetFilter } = useAssetListFilter();
  const { mutateAsync } = useSetAssetListFilter();

  const updateSearch = async (keyword: string) => {
    if (assetFilter) {
      assetFilter.keyword = keyword;
      await mutateAsync(assetFilter);
    }
  };

  return (
    <SearchWrapper
      mode={mode}
      onBack={onBack}
      isVisible={isVisible}
      onDismiss={onDismiss}
      recentSearchesKey="asset_recent_searches"
      currentKeyword={assetFilter?.keyword}
      onSearchUpdate={updateSearch}
      searchPlaceholder={t('assets.filter.searchPlaceholder')}
      searchButtonKey="assets.filter.search"
      recentSearchesTitleKey="assets.filter.recentSearches"
    />
  );
}
